var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.mealOptions,"item-text":"name","item-value":"name","label":_vm.mealType},on:{"change":_vm.updateMeal},model:{value:(_vm.selectedMeal),callback:function ($$v) {_vm.selectedMeal=$$v},expression:"selectedMeal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }